<template>
  <div>
    <p class="text-2xl mb-6">Liste des Mappings</p>
    <v-col cols="12" class="d-flex flex-row-reverse">
      <v-btn color="primary" link :to="{ name: 'finance-create-mapping' }">
        <v-icon class="mr-3">{{ icons.mdiPlusBox }}</v-icon
        >Créer un nouveau mapping</v-btn
      >
    </v-col>
    <filters />
    <v-col cols="12"> <mapping-table /> </v-col>
  </div>
</template>

<script>
import { mdiPlusBox } from "@mdi/js";
import Filters from "@/components/finance/mapping/filters/Filters";
import MappingTable from "@/components/finance/mapping/tables/MappingTable";

export default {
  name: "FinanceMappingList",
  components: {
    Filters,
    MappingTable,
  },
  setup(props, { emit }) {
    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      icons: {
        mdiPlusBox,
      },
    };
  },
};
</script>

<style></style>
